import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { store, persistor } from './redux/store';
import { RouterProvider } from 'react-router-dom';
import '@radix-ui/themes/styles.css';
import './styles/custom.css';
import { router } from './routes';
import LoadingSpinner from './components/LoadingSpinner';
import './styles/custom-font.css';
import { generateToken, messaging } from './firebase/firebase';
import { useEffect } from 'react';
import { onMessage } from 'firebase/messaging';
import { toast } from 'react-toastify';
import CustomToast from './components/common/CustomToast';
import { ConfirmDialogProvider } from './contexts/confirmDialog';
import { ConfirmDialog } from './components/common/ConfirmDialog';

function App() {
  useEffect(() => {
    generateToken();
  }, []);

  return (
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <ConfirmDialogProvider>
        <RouterProvider router={router} />
          <ConfirmDialog />
        </ConfirmDialogProvider>
      </PersistGate>
    </Provider>
  );
}

export default App;
